//Error Handling Reducer

const errorHandlerReducerDefaultState = {
    code    : undefined,
    message : ''
};

export default (state = errorHandlerReducerDefaultState, action) => {
    switch(action.type) {
        case 'SET_ERROR_STATE':
            return {
                ...state,
                code    : action.code,
                message : action.message
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/Reducers/errorHandler.js